export const QUESTION_TYPE = {
  step2: [1, 2, 3, 4],
  step3: [5, 6, 7, 8],
};
